export { getDictionary, getTranslation } from "./getDictionary";
export { i18n } from "./i18nConfig";
export type { Locale } from "./i18nConfig";
